import { defineStore } from 'pinia';
import { ref } from 'vue';

import { createConfigCatClient } from '@/plugins/configcat';

export const useConfigCatStore = defineStore('configCat', () => {
    const userManagementTab = ref<boolean>(false);
    const onboarding = ref<boolean>(false);
    const retryIndexing = ref<boolean>(false);
    const datasourceRagType = ref<boolean>(false);
    const isAdmin = ref<boolean>(false);
    const maxPresentationFileSize = ref<number>(15);
    const webButton = ref<boolean>(true);
    const slideLibrary = ref<boolean>(false);
    const managePptTemplates = ref<boolean>(false);
    const browsePptTemplates = ref<boolean>(false);
    const azureGroups = ref<boolean>(false);
    const elqanoCollection = ref<boolean>(false);
    const isPowerpointEnabled = ref<boolean>(false);
    const slideStudio = ref<boolean>(false);
    const isSlideEditorEnabled = ref<boolean>(false);
    const gemini3FlashEnabled = ref<boolean>(false);
    const claudeOpusEnabled = ref<boolean>(false);
    const claudeSonnetEnabled = ref<boolean>(false);
    const canCreateCustomAgents = ref<boolean>(false);
    const isCustomAgentsEnabled = ref<boolean>(false);
    const isGlobalAgentsEnabled = ref<boolean>(false);
    const isSavedPromptEnabled = ref<boolean>(false);
    const agentV2 = ref<boolean>(false);

    async function fetchConfigCatFlags(user: any) {
        if (user) {
            const configCatClient = createConfigCatClient(
                user.userId,
                user.email
            );

            userManagementTab.value = await configCatClient.getValueAsync(
                'userManagementTab',
                false
            );
            onboarding.value = await configCatClient.getValueAsync(
                'onboarding',
                false
            );
            retryIndexing.value = await configCatClient.getValueAsync(
                'retry_indexing_button',
                false
            );
            datasourceRagType.value = await configCatClient.getValueAsync(
                'datasourceRagType',
                false
            );
            isAdmin.value = await configCatClient.getValueAsync(
                'isAdmin',
                false
            );
            maxPresentationFileSize.value = await configCatClient.getValueAsync(
                'presentationFileMaxSize',
                15
            );
            webButton.value = await configCatClient.getValueAsync(
                'webButton',
                true
            );
            slideLibrary.value = await configCatClient.getValueAsync(
                'slidelibrary',
                false
            );
            managePptTemplates.value = await configCatClient.getValueAsync(
                'managePptTemplates',
                false
            );
            browsePptTemplates.value = await configCatClient.getValueAsync(
                'browsePptTemplates',
                false
            );
            azureGroups.value = await configCatClient.getValueAsync(
                'azureGroups',
                false
            );
            elqanoCollection.value = await configCatClient.getValueAsync(
                'elqanoCollection',
                false
            );
            isPowerpointEnabled.value = await configCatClient.getValueAsync(
                'isPowerpointEnabled',
                false
            );
            slideStudio.value = await configCatClient.getValueAsync(
                'slideStudio',
                false
            );
            isSlideEditorEnabled.value = await configCatClient.getValueAsync(
                'isSlideEditorEnabled',
                false
            );
            claudeOpusEnabled.value = await configCatClient.getValueAsync(
                'claudeopus46',
                false
            );
            gemini3FlashEnabled.value = await configCatClient.getValueAsync(
                'geminiflash3',
                false
            );
            claudeSonnetEnabled.value = await configCatClient.getValueAsync(
                'claudesonnet',
                false
            );
            canCreateCustomAgents.value = await configCatClient.getValueAsync(
                'canCreateCustomAgents',
                false
            );
            isCustomAgentsEnabled.value = await configCatClient.getValueAsync(
                'customagentbutton',
                false
            );
            isGlobalAgentsEnabled.value = await configCatClient.getValueAsync(
                'isGlobalAgentEnabled',
                false
            );
            isSavedPromptEnabled.value = await configCatClient.getValueAsync(
                'isSavedPromptEnabled',
                false
            );
            agentV2.value = await configCatClient.getValueAsync(
                'agentV2',
                false
            );
        }
    }

    return {
        userManagementTab,
        onboarding,
        fetchConfigCatFlags,
        retryIndexing,
        datasourceRagType,
        isAdmin,
        maxPresentationFileSize,
        webButton,
        slideLibrary,
        managePptTemplates,
        browsePptTemplates,
        azureGroups,
        elqanoCollection,
        isPowerpointEnabled,
        slideStudio,
        isSlideEditorEnabled,
        gemini3FlashEnabled,
        claudeOpusEnabled,
        claudeSonnetEnabled,
        canCreateCustomAgents,
        isCustomAgentsEnabled,
        isGlobalAgentsEnabled,
        isSavedPromptEnabled,
        agentV2
    };
});
